module.exports = __webpack_public_path__ + "assets/apollo.393e9a67.svg";